module.exports = __webpack_public_path__ + "img/paimai02.06fb8fb6.jpg";